// src/ForestLifeEducation.tsx

import React from 'react';
import {
  Sun,
  Trees,
  Heart,
  BookOpen,
  Sparkles,
  Stars,
} from 'lucide-react';
import './ForestLifeEducation.css';

const lifeItems = [
  { icon: <Sun />, title: '好奇心是陽光', text: '真正驅動學習的，不是分數，而是想探索世界的渴望。' },
  { icon: <Sun />, title: 'AI 是工具', text: '照亮未知，幫助孩子看見更大的世界。' },
  { icon: <Trees />, title: '自然是空氣', text: '回到自然，重新感受生命真正的節奏。' },
  { icon: <Heart />, title: '陪伴是水', text: '每個孩子，都需要被理解與陪伴。' },
  { icon: <Sparkles />, title: '失敗是肥料', text: '真正的成長，往往來自跌倒後再次站起。' },
  { icon: <BookOpen />, title: '閱讀是年輪', text: '一本本書，慢慢形成生命的厚度。' },
  { icon: <Stars />, title: '星星是世界觀', text: '抬頭看世界，人生才不會只剩考試與分數。' },
];

const ForestLifeEducation: React.FC = () => {
  return (
    <div className="forest-life-page">
      <section className="forest-life-hero">
        <div className="overlay"></div>

        <div className="hero-content">
          <span className="hero-badge">
            🌳 Forest School Life Education
          </span>

          <h1>
            森林學校生命教育
          </h1>

          <p>
            不是把孩子變成考試機器，
            <br />
            而是陪伴一顆種子，
            慢慢長成一片森林。
          </p>
        </div>
      </section>

      <section className="forest-life-intro section-width">
        <h2>生命，不是競爭，而是成長</h2>

        <p>
          森林裡，沒有兩棵一模一樣的樹。
          有的高大，有的緩慢，
          有的向陽，有的耐風雨。
        </p>

        <p>
          森林從不比較，
          而是彼此共生。
        </p>
      </section>

      <section className="forest-life-grid section-width">
        {lifeItems.map((item) => (
          <div className="life-card" key={item.title}>
            <div className="life-icon">
              {item.icon}
            </div>

            <h3>{item.title}</h3>

            <p>{item.text}</p>
          </div>
        ))}
      </section>

      <section className="forest-long-text section-width">
        <div className="forest-quote-card">
          <p>好奇心是陽光，AI 是工具，自然是空氣，陪伴是水。</p>
         
          <p>
            失敗是肥料，
            反省是修枝，
            感恩是養分，
            珍惜是扎根。
          </p>

          <p>
            閱讀是年輪，
            紀律是樹幹，
            熱愛是種子。
          </p>

          <p>
            而那些看不見的善意與關懷，
            是土壤中的微生物。
          </p>

          <p className="highlight">
            星星，是世界觀。
          </p>

          <p>
            它提醒孩子：
            不要只低頭看腳下，
            也要抬頭看見更大的世界。
          </p>

          <p>
            尊重差異，
            包容不同，
            每個生命，
            都有自己的節奏與季節。
          </p>

          <p className="highlight">
            長期主義，
            是相信每一顆種子，
            都有機會長成大樹。
          </p>

          <p>
            真正的成長，
            不是一夜爆紅，
            而是日復一日扎根，
            在風雨中慢慢長大。
          </p>

          <p className="highlight">
            價值觀，
            是森林裡的芬多精。
          </p>

          <p>
            真正成熟的人，
            不只追求自己的成功，
            也願意幫助別人一起成長。
          </p>

          <p>
            利他，
            會讓整片森林的空氣，
            變得更加清新。
          </p>

          <p>
            微生物默默分解痛苦，
            修復受傷的心，
            讓生命重新恢復力量。
          </p>

          <p className="ending">
            而時間，
            會慢慢把一顆種子，
            長成一片森林。 🌳✨
          </p>
        </div>
      </section>
    </div>
  );
};

export default ForestLifeEducation;